export const bestPractices_Marketplaces = [
	{
		icon: '✅',
		title: 'bestPracticesData_title1',
		subtitle: 'bestPracticesData_subtitle1',
	},
	{
		icon: '✅',
		title: 'bestPracticesData_title2',
		subtitle: 'bestPracticesData_subtitle2',
	},
	{
		icon: '✅',
		title: 'bestPracticesData_title3',
		subtitle: 'bestPracticesData_subtitle3',
	},
	{
		icon: '✅',
		title: 'bestPracticesData_title4',
		subtitle: 'bestPracticesData_subtitle4',
	},
	{
		icon: '✅',
		title: 'bestPracticesData_title5',
		subtitle: 'bestPracticesData_subtitle5',
	},
];
